export default "__VITE_ASSET__DeL9hFVy__"